import React from 'react';
import CustomIcon from '../Common/CustomIcon/CustomIcon';

// Styles
import style from './Screenshot.module.css';

import {
	broncoURL,
} from 'Vulture/ENV.js';

import {
	getSession,
} from 'Vulture/Session';

import axios from 'axios';
import {
	s3,
} from 'S3';
import Img from 'wrapper/Img';
import { s3PublicURL } from 'Vulture/S3.js';

class ScreenshotModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			displayName:  '',
			macAddress:   '',
			salesforceID: '',
			systemUUID:   '',
			versions:     [],
			currentImage: props.screenshotURL,
			currentDate:  props.obj.lastModified,
			currentIndex: 0,
		};
	}

	componentDidMount() {
		const {
			obj,
		} = this.props;

		s3.listObjectVersions({
			Bucket:	   'ts-screen-shots',
			Delimiter: '/',
			Prefix:	   `${obj.imgKey}`,
		},
		(err, data) => {
			if (err) {
				console.error(err);
				return;
			}

			this.setState({
				versions: data.Versions,
			});
		});
		const session = getSession();
		const body = {
			tlc: obj.tlcUUID,
		};
		const headers = {
			'X-Auth-Session': session.session,
		};
		axios.post(`${broncoURL}/tlc`, body, headers)
			.then((result) => {
				this.setState({
					displayName:  result.data.displayName,
					macAddress:   result.data.macAddress,
					salesforceID: result.data.salesforceID,
					systemUUID:   result.data.systemUUID,
				});
			});
	}

	closeModal() {
		const {
			app,
		} = this.props;

		app.closeModal();
	}

	render() {
		const {
			obj,
		} = this.props;

		return (
			<div className={style.screenshotModal}>
				<div className={style.sectionLabel}>{`Screenshot ${this.state.currentIndex + 1}/${this.state.versions.length}`}</div>
				<div className={style.sectionImage}>
					<button
						className={`${style.arrowButton} button`}
						data-test-id="screenshotModalBackButton"
						onClick={() => {
							const nextIndex = ((this.state.currentIndex - 1) + this.state.versions.length) % this.state.versions.length;
							const nextImage = s3PublicURL('ts-screen-shots', `${(this.state.versions[nextIndex].Key)}?versionId=${this.state.versions[nextIndex].VersionId}`);
							const nextDate = this.state.versions[nextIndex].LastModified;

							this.setState({
								currentIndex: nextIndex,
								currentImage: nextImage,
								currentDate:  nextDate,
							});
						}
						}>
						<CustomIcon icon="arrow-circle-left" />
					</button>
					<div className={style.imageSection}>
						<a href={this.state.currentImage} target="_blank" rel="noopener noreferrer">
							<Img data-test-id="screenshotModalImage" src={this.state.currentImage} alt={`Expanded screenshot of ${obj.tlcUUID}`} />
						</a>
					</div>
					<button
						className={`${style.arrowButton} button`}
						data-test-id="screenshotModalNextButton"
						onClick={() => {
							const nextIndex = (this.state.currentIndex + 1) % this.state.versions.length;
							const nextImage = s3PublicURL('ts-screen-shots', `${(this.state.versions[nextIndex].Key)}?versionId=${this.state.versions[nextIndex].VersionId}`);
							const nextDate = this.state.versions[nextIndex].LastModified;

							this.setState({
								currentIndex: nextIndex,
								currentImage: nextImage,
								currentDate:  nextDate,
							});
						}
						}>
						<CustomIcon icon="arrow-circle-right" />
					</button>
				</div>
				<div className={style.fileSize}>
					{`${obj.resolution}, ${obj.size}`}
				</div>
				<div className={style.twoInfoContainer}>
					<div className={`text-small ${style.description}`}>
						<div className={`label ${style.label}`}>
							<label>System</label>
						</div>
						<input
							value={this.state.displayName}
							data-test-id="screenshotModalSystemInput"
							type='text'
							disabled
						/>
					</div>
					<div className={`text-small ${style.description}`}>
						<div className={`label ${style.label}`}>
							<label>System UUID</label>
						</div>
						<input
							value={this.state.systemUUID}
							data-test-id="screenshotModalSystemUuidInput"
							type='text'
							disabled
						/>
					</div>
				</div>
				<div className={style.twoInfoContainer}>
					<div className={`text-small ${style.description}`}>
						<div className={`label ${style.label}`}>
							<label>Mac Address</label>
						</div>
						<input
							value={this.state.macAddress}
							data-test-id="screenshotModalMacAddressInput"
							type='text'
							disabled
						/>
					</div>
					<div className={`text-small ${style.description}`}>
						<div className={`label ${style.label}`}>
							<label>Salesforce ID</label>
						</div>
						<input
							value={this.state.salesforceID}
							data-test-id="screenshotModalSalesforceIdInput"
							type='text'
							disabled
						/>
					</div>
				</div>
				<div className={`text-small ${style.description}`}>
					<div className={`label ${style.label}`}>
						<label>Date</label>
					</div>
					<input
						value={this.state.currentDate.toString()}
						data-test-id="screenshotModalDateInput"
						type='text'
						disabled
					/>
				</div>
			</div>
		);
	}
}

export default ScreenshotModal;